import {css, unsafeCSS} from 'lit';
import {brand_text, logo} from '../../../../styles/images';

// language=CSS
export const styles = css`
    :host {
        background-color: var(--color-primary);
        display: grid;
        grid-auto-flow: column;
        column-gap: var(--padding-default);
        place-content: center start;
        padding-left: var(--padding-default);
    }

    .logo {
        background-image: url(${unsafeCSS(logo)});
        width: 1.5rem;
        height: 2rem
    }

    .brand-text {
        background-image: url(${unsafeCSS(brand_text)});
        background-repeat: no-repeat;
        height: 1.0625rem;
        width: 4.25rem;
        margin-top: 0.65rem;
    }
`;
